import { render, staticRenderFns } from "./BoxHeader.vue?vue&type=template&id=25df6c5b&"
import script from "./BoxHeader.vue?vue&type=script&lang=js&"
export * from "./BoxHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports